export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const AGREESMS = 'AGREESMS';
export const UPDATECALCULATEHOUR = 'UPDATECALCULATEHOUR';
export const SETCONSENTDOCID = 'SETCONSENTDOCID';

export const login = (loginInfo) => ({
  type: LOGIN,
  loginInfo: loginInfo,
});

export const logout = () => ({
  type: LOGOUT,
});

export const agreeSms = (flag) => ({
  type: AGREESMS,
  flag,
});

export const updateCalculateHour = (calculateHour) => ({
  type: UPDATECALCULATEHOUR,
  calculateHour,
});

export const setConsentDocId = (consentDocId) => ({
  type: SETCONSENTDOCID,
  consentDocId,
});